var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import { ExternalDamageComponent } from '@declaration/components/externalDamage/ExternalDamageComponent';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
import { DOOR_MATERIALS_CHOICES } from '@shared/constants/externalDamages/DoorConstants';
import { DOOR_MATERIALS_TITLE } from '@declaration/constants/externalDamages/DoorConstants';
let DoorMaterials = class DoorMaterials extends ExternalDamageComponent {
    constructor() {
        super(...arguments);
        this.doorMaterialChoices = DOOR_MATERIALS_CHOICES;
    }
    get material() {
        return this.externalDamage.doorMaterial;
    }
    set material(doorMaterial) {
        this.updateExternalDamage({ doorMaterial });
    }
    get title() {
        return this.translateExternalDamageKey(DOOR_MATERIALS_TITLE);
    }
};
DoorMaterials = __decorate([
    Component({ components: { RadioPrimaryButton } })
], DoorMaterials);
export default DoorMaterials;
